export default __webpack_public_path__ + "static/media/filter_active.a1abe08d.svg";